/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 157);
/******/ })
/************************************************************************/
/******/ ({

/***/ 121:
/***/ (function(module, exports) {

module.exports = PIXI.settings;

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_fs__ = __webpack_require__(158);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "options", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "app", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "modes", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "renderer", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sprite", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "style", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "basicText", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sound", function() { return __WEBPACK_IMPORTED_MODULE_0__App_fs__["f"]; });


/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return options; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return app; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return modes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return renderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return sprite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return style; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return basicText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sound; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_PIXI__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_PIXI___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_PIXI__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_PIXI_settings__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_PIXI_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_PIXI_settings__);


var options = {
  backgroundColor: 0
};
var app = new __WEBPACK_IMPORTED_MODULE_0_PIXI__["Application"](400, 400, options);
document.body.appendChild(app.view);
var modes = {};
__WEBPACK_IMPORTED_MODULE_1_PIXI_settings__["SCALE_MODE"] = modes.NEAREST;
var renderer = app.renderer;
var sprite = __WEBPACK_IMPORTED_MODULE_0_PIXI__["Sprite"].fromImage("../img/fable_logo_small.png");
sprite.anchor.set(0.5);
sprite.x = renderer.width * 0.5;
sprite.y = renderer.height * 0.5;
sprite.interactive = true;
sprite.buttonMode = true;
app.stage.addChild(sprite);
var style = {
  strokeThickness: 5,
  fill: ["#ffffff", "#1292FF"],
  fontWeight: "bold",
  fontStyle: "italic",
  fontSize: 36,
  fontFamily: "Arial"
};
var basicText = new __WEBPACK_IMPORTED_MODULE_0_PIXI__["Text"]("Click on the dragon!", style);
basicText.anchor.set(0.5);
basicText.x = renderer.width * 0.5;
basicText.y = 90;
app.stage.addChild(basicText);
var sound = __WEBPACK_IMPORTED_MODULE_0_PIXI__["sound"].Sound.from("../sounds/applause.ogg");
sprite.on("pointerdown", function () {
  var scale = sprite.scale;
  scale.x = scale.x * 1.25;
  scale.y = scale.y * 1.25;
  sound.play();
});

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = PIXI;

/***/ })

/******/ });


// WEBPACK FOOTER //
// sound/bundle.js